import type { Account, Transaction } from "@/lib/finance";
import type { CategoryStatus } from "@/lib/budget";

export type Period = "monthly" | "quarterly" | "yearly";
export interface SeriesPoint { key: string; income: number; expense: number; net: number }
export interface WealthPoint { key: string; liquid: number; goods: number; debts: number; net_worth: number; liquid_worth: number }
export interface CompositionCat { name: string; group: CompGroup; amount: number }
export type CompGroup = "essentials" | "comfort" | "debt" | "savings_investment" | "uncategorized";

export interface BigPayment { item_id: string; name: string; kind: string; frequency: "quarterly" | "semiannual" | "annual"; month: string; amount: number; months_left: number; monthly_save: number }

export interface DashboardResponse {
  interest_paid_year?: number;
  card_interest_month?: number;
  has_liabilities?: boolean;
  today: string;
  month: string;
  period: Period;
  net_worth: number;
  assets_total: number;
  liabilities_total: number;
  invested_total: number;
  liquid_total: number;
  month_summary: { income_total: number; expense_total: number; balance: number };
  planned_income: number;
  planned_expense: number;
  month_flow: { income: number; spending: number; debt: number; savings: number; outflow: number; balance: number };
  planned_debt?: number;
  series: SeriesPoint[];
  liquidity: { total: number; bank: number; savings_investment: number; avg_monthly_expense: number; months_covered: number | null };
  current_bucket: string;
  composition: { groups: Record<CompGroup, number>; categories: CompositionCat[] };
  projection: { avg_monthly_savings: number; months_considered: number };
  recent: Transaction[];
  budget: { id: string; name: string; actual_month_amount: number; effective_limit: number; progress_ratio: number | null; status: CategoryStatus; helper_text: string }[];
  month_progress_ratio: number;
  upcoming: { schedule_id: string; date: string; type: string; description: string; amount: number; label: string }[];
  big_payments: BigPayment[];
  msi_commitments?: { total: number; by_month: { month: string; amount: number }[] };
  unrecorded_diff?: number;
  accounts: Account[];
}

const SHORT = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];

export const bucketLabel = (key: string, period: Period) => {
  if (period === "monthly") return `${SHORT[Number(key.slice(5, 7)) - 1]} ${key.slice(2, 4)}`;
  if (period === "quarterly") return `${key.slice(5)} ${key.slice(2, 4)}`;
  return key;
};

export const PERIOD_LABELS: Record<Period, string> = { monthly: "Mensual", quarterly: "Trimestral", yearly: "Anual" };
export const CURRENT_LABEL: Record<Period, string> = { monthly: "este mes", quarterly: "este trimestre", yearly: "este año" };

export const COMP_LABELS: Record<CompGroup, string> = {
  savings_investment: "Ahorro e Inversión", essentials: "Esenciales", comfort: "Comodidad", debt: "Deudas", uncategorized: "Sin categoría",
};
export const COMP_COLORS: Record<CompGroup, string> = {
  savings_investment: "#2C4F91", essentials: "#16294D", comfort: "#9DB2D6", debt: "#9C3D24", uncategorized: "#CBB898",
};
